import * as React from 'react';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';
import { AlertItemState } from '../../stores/alerts/reducer';
import { RootState } from '../../stores/store';
import './AlertContainer.scss';
import AlertItem from './AlertItem';

interface AlertsProps {
    alerts: AlertItemState[];
}

class AlertContainer extends React.Component<AlertsProps> {
    constructor(props: AlertsProps) {
        super(props);
    }

    public render() {
        return (
            <div className="tpm-alert-container-top-right">
                <TransitionGroup>
                    {this.props.alerts.map((alert) => (
                        <AlertItem
                            key={alert.id}
                            id={alert.id}
                            type={alert.type}
                            color={alert.color}
                            title={alert.title}
                            message={alert.message}
                        />
                    ))}
                </TransitionGroup>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState): AlertsProps => ({
    alerts: state.alerts
});

export default connect(mapStateToProps)(AlertContainer);
